import React, { useEffect, useState } from 'react';
import { Breadcrumbs, Link, Typography } from '@mui/material';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import axios from 'axios';
import BASE_API_URL from '../apis/index';
import UserCROServiceRegistrationForm from '../components/UserCROServiceRegistrationForm';

function UserServiceCROEdit() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const servId = queryParams.get("servId");
    const compId = queryParams.get("compId");
    const compName = queryParams.get("compName");

    const [formData, setFormData] = useState(null);

    // ✅ Fetch CRO Service Details
    useEffect(() => {
        if (!servId) return;

        const fetchService = async () => {
            try {
                const authToken = localStorage.getItem("authToken");

                const res = await axios.get(
                    `${BASE_API_URL}/api/seller/service/cro/${servId}`,
                    { headers: { Authorization: `Bearer ${authToken}` } }
                );

                const service = res.data;

                // ✅ Prepare Existing QMS File (single file field)
                const existingQmsDoc = service.qms_file
                    ? [{
                        id: 1,
                        file: service.qms_file,
                        name: "QMS Document"
                    }]
                    : [];

                setFormData({
                    serviceCatalog: service.service_catalog || [],
                    geographicReach: service.geographic_reach || [],
                    employeeCount: service.employee_count || "",
                    qmsStatus: service.qms_status || "no",
                    qmsFile: existingQmsDoc,   // prefilled QMS document
                    complianceStatement: service.compliance_statement || "",
                    pastAuditDate: service.past_audit_date
                        ? service.past_audit_date.split("T")[0]
                        : "",
                    sopFollowing: service.sop_following || "no",

                    // These are for handling new uploads
                    newQmsFile: null,
                });

            } catch (err) {
                console.error("❌ Error fetching CRO service:", err);
            }
        };

        fetchService();
    }, [servId]);

    return (
        <Wrapper className='container'>
            <Breadcrumbs aria-label="breadcrumb" className="mb-5 mt-2 pageBreadCrumbs">
                <Link color="inherit" href={`/user-company-details?compId=${compId}`}>{compName}</Link>
                <Typography className='text-secondary'>Editing CRO Service</Typography>
            </Breadcrumbs>

            <h2 className="pageTitle after_title_line"> Edit CRO Service for <span className="txt_color_secondary"> {compName}</span></h2>

            <UserCROServiceRegistrationForm
                compId={compId}
                compName={compName}
                initialData={formData}
                isEdit={true}
                serviceId={servId}
            />
        </Wrapper>
    );
}

export default UserServiceCROEdit;

const Wrapper = styled.div``;
